import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import { Menu } from "../../../components/menu-consultas";

export const LayoutConsultaBike: React.FC = ({ children }) => {
  const { pathname } = useLocation();

  return (
    <MUI.Stack pt={[2, 0]} flexDirection="row" width="100%" height="80vh">
      <Menu
        titulo="Alerta Bike"
        menu={[
          {
            to: "/alerta/consulta-bike",
            label: "Consulta Bike",
            icon: <Icon.PedalBike sx={{ color: "white" }} />,
            isSelected: pathname === "/alerta/consulta-bike",
          },
          {
            to: "/pagina-inicial",
            label: "Voltar página inicial",
            icon: <Icon.KeyboardReturn sx={{ color: "white" }} />,
            isSelected: pathname === "/pagina-inicial",
          },
        ]}
      />
      <MUI.Stack flex={1} padding={2} gap={1} overflow="auto">
        {children}
      </MUI.Stack>
    </MUI.Stack>
  );
};
